/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useEffect, useState} from 'react';

/**
 * useViewSubGroups provides internal state and setter with a
 * boolean value for viewSubGroups used by all the Admin grids
 *
 * ```typescript
 *
 * import { useViewSubGroups } from '@ion/dls/src/hooks/';
 *
 * const [viewSubGroups, toggleViewSubGroups] = useViewSubGroups();
 * ```
 */
export function useViewSubGroups(view = true): [boolean, (viewSubGroups: boolean) => void] {
  const [viewSubGroups, setViewSubGroups] = useState<boolean>(view);
  useEffect(() => {
    setViewSubGroups(view);
  }, [view]);
  return [viewSubGroups, setViewSubGroups];
}
export default useViewSubGroups;
